import { PublicChannel, } from '@wix/wix-vod-api-site-based/public';
import { toError } from '../../parsers/to-error';
import { keysToCamelCase, keysToSnakeCase } from '@wix/wix-vod-shared/common';
import { CHANNEL_TYPES, URL_TYPES } from '@wix/wix-vod-constants/common';
import { parseChannel } from './parsers/channel';
import { YoutubeService } from '../youtube/pixwix/youtube';
const extractCoverFromVideoItem = (videoItem) => videoItem.custom_cover_url || videoItem.cover_url;
export class PublicChannelService {
    constructor(httpClient, baseUrl) {
        this.httpClient = httpClient;
        this.baseUrl = baseUrl;
        this.getVideoPreviewUrls = async (channelId, instance) => {
            let response;
            try {
                response = await this.siteBasedPublicChannelService.getVideoPreviewUrls(channelId, instance);
            }
            catch (err) {
                return toError(err);
            }
            return response.data;
        };
        this.getMemberInfo = async (channelId, instance) => {
            let response;
            try {
                response = await this.siteBasedPublicChannelService.getMemberInfo(channelId, instance);
            }
            catch (err) {
                return toError(err);
            }
            return keysToCamelCase(response);
        };
        this.getInfo = async (channelId, templateMetaSiteId) => {
            try {
                const response = await this.siteBasedPublicChannelService.getInfo(channelId, {
                    params: { metaSiteId: templateMetaSiteId },
                });
                try {
                    const externalResponse = await this.getExternalChannelInfo(response.data);
                    Object.assign(response.data, {
                        youtube_data: externalResponse.data,
                    });
                }
                catch (e) {
                    // not external, or youtube pix.wix request failed
                }
                const channel = keysToSnakeCase(response.data);
                if (channel.youtube_data) {
                    // @ts-expect-error
                    channel.youtube_data = keysToCamelCase(channel.youtube_data);
                }
                const { custom_cover_url, cover_url, featured_item, channel_type } = channel;
                if (!custom_cover_url &&
                    !cover_url &&
                    featured_item &&
                    channel_type !== CHANNEL_TYPES.YOUTUBE_FEED) {
                    channel.cover_url = extractCoverFromVideoItem(featured_item);
                }
                return parseChannel(channel);
            }
            catch (error) {
                return toError(error);
            }
        };
        this.siteBasedPublicChannelService = new PublicChannel(httpClient, baseUrl);
        this.youtubeService = new YoutubeService(httpClient);
    }
    isYoutubeChannel(channel) {
        return (channel.channel_type === CHANNEL_TYPES.YOUTUBE_FEED &&
            channel.url_type === URL_TYPES.CHANNEL);
    }
    isYoutubePlaylist(channel) {
        return (channel.channel_type === CHANNEL_TYPES.YOUTUBE_FEED &&
            channel.url_type === URL_TYPES.PLAYLIST);
    }
    /**
     Fetch youtube channel by playlistId or channelId
     @param channel
     **/
    getExternalChannelInfo(channel) {
        if (channel.external_id && this.isYoutubeChannel(channel)) {
            return this.youtubeService.getChannelById(channel.external_id);
        }
        if (channel.external_id && this.isYoutubePlaylist(channel)) {
            return this.youtubeService.getPlaylistById(channel.external_id);
        }
        throw new Error('Method is not allowed');
    }
}
//# sourceMappingURL=channel.js.map